var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M20.3351 4.72912C20.2083 4.60312 20.0591 4.53975 19.8866 4.53975C19.8007 4.53975 19.6196 4.61025 19.3443 4.74937C19.0687 4.88887 18.7762 5.04412 18.4683 5.21737C18.1597 5.3895 17.7944 5.5455 17.3729 5.685C16.9518 5.82412 16.5618 5.89462 16.2029 5.89462C15.8714 5.89462 15.5789 5.83162 15.3269 5.70525C14.4911 5.31375 13.7639 5.02162 13.1467 4.82887C12.5294 4.6365 11.8657 4.53975 11.1551 4.53975C9.92806 4.53975 8.53044 4.93875 6.96369 5.73525C6.64044 5.8965 6.40869 6.02138 6.25869 6.11288L6.10981 5.02125C6.44619 4.72913 6.66331 4.3035 6.66331 3.82312C6.66331 2.943 5.95006 2.22975 5.06994 2.22975C4.18981 2.22975 3.47656 2.943 3.47656 3.82312C3.47656 4.39725 3.78331 4.89637 4.23856 5.17687L6.39106 20.9606C6.45519 21.4305 6.85719 21.7714 7.31881 21.7714C7.36081 21.7714 7.40356 21.7688 7.44669 21.7631C7.95969 21.6926 8.31894 21.2205 8.24881 20.7075L7.38369 14.3636C8.95344 13.5848 10.3113 13.1921 11.4536 13.1921C11.9384 13.1921 12.4113 13.2645 12.8722 13.4108C13.3334 13.5574 13.7171 13.7164 14.0223 13.8885C14.3276 14.061 14.6879 14.2208 15.1023 14.3663C15.5174 14.5125 15.9273 14.5856 16.3319 14.5856C17.3542 14.5856 18.5786 14.2005 20.0054 13.4306C20.1847 13.3376 20.3159 13.2461 20.3988 13.1565C20.4817 13.0669 20.5233 12.9394 20.5233 12.7736V5.17725C20.5233 5.00512 20.4607 4.8555 20.3351 4.72912Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }